import SelectIcon from "./SelectIcon";

export default SelectIcon;
